import { render, staticRenderFns } from "./in-switch.vue?vue&type=template&id=33aad13a"
import script from "./in-switch.vue?vue&type=script&lang=js"
export * from "./in-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports